var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordsArchives(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_209_764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.84375 8.4375L1.73047 9.375L0 8.4375L1.90625 5.625L2.84375 6.5625V8.4375Z",
    fill: "#47568C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1562 8.4375L14.2695 9.375L16 8.4375L14.0938 5.625L13.1562 6.5625V8.4375Z",
    fill: "#2C3B73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2188 0V5.15625H3.78125V0.9375H7.74683L8 0.5625L8.375 0H12.2188Z",
    fill: "#FFDA2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2188 0V5.15625H8V0.5625L8.375 0H12.2188Z",
    fill: "#FDBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1562 1.875V7.03125H2.84375V2.8125H8.68433L9.3125 1.875H13.1562Z",
    fill: "#FDBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1562 1.875V7.03125H8V2.8125H8.68433L9.3125 1.875H13.1562Z",
    fill: "#FF9100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0938 3.75V10.7812H1.90625V4.6875H9.62183L10.25 3.75H14.0938Z",
    fill: "#FFDA2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0938 3.75V10.7812H8V4.6875H9.62183L10.25 3.75H14.0938Z",
    fill: "#FDBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.4375V16H0V8.4375H6.1532L6.46252 9.375H9.53748L9.8468 8.4375H16Z",
    fill: "#61729B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.4375V16H8V9.375H9.53748L9.8468 8.4375H16Z",
    fill: "#47568C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.65625 11.25H10.3437V12.1875H5.65625V11.25Z",
    fill: "#FFDA2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.25H10.3438V12.1875H8V11.25Z",
    fill: "#FDBF00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_209_764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordsArchives);
export default __webpack_public_path__ + "static/media/RecordsArchives.9b8d66c8befe3d6d95d4b96126bbf986.svg";
export { ForwardRef as ReactComponent };